import { computed, ref } from 'vue'

import {
  MonthlyTurnover,
  SignupRequestBody,
  SignupType,
} from '@/app/types/api/resources/auth'

import getReferralToken from '@/utils/getReferralToken'

export interface SignupFormData {
  email: string
  companyName: string
  turnover: MonthlyTurnover | null
  phone: string
  social: string
  username: string
  password: string
  registration_type: SignupType
}

export default function () {
  const formData = ref<SignupFormData>({
    email: '',
    companyName: '',
    turnover: null,
    phone: '',
    social: '',
    username: '',
    password: '',
    registration_type: SignupType.Auth,
  })

  const formattedPhone = ref('')

  const signupRequestBody = computed<SignupRequestBody>(() => {
    const referralToken = getReferralToken()

    return {
      email: formData.value.email,
      username: formData.value.username,
      password: formData.value.password,
      password_confirmation: formData.value.password,
      registration_type: SignupType.Auth,
      referral_token: referralToken,
      commercial_data: {
        company_name: formData.value.companyName,
        monthly_turnover: formData.value.turnover ?? ('' as MonthlyTurnover),
        contact_phone: formattedPhone.value,
        social_contact: formData.value.social,
      },
    }
  })

  const turnoverOptions: MonthlyTurnover[] = Object.values(MonthlyTurnover)

  const isPhoneValid = ref(true)

  function handlePhoneValidation(phoneObj: any) {
    formattedPhone.value = phoneObj.number

    if (phoneObj.valid === undefined) {
      isPhoneValid.value = true

      return
    }

    isPhoneValid.value = phoneObj.valid
  }

  return {
    formData,
    signupRequestBody,
    turnoverOptions,
    isPhoneValid,
    handlePhoneValidation,
  }
}
